import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import VueRouter from 'vue-router';

// 进度条
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '@/store/index';
import util from '@/libs/util.js';

// 路由数据
import routes from './routes';
// console.log('routes',routes)

// fix vue-router NavigationDuplicated
var VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch(function (err) {
    return err;
  });
};
var VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch(function (err) {
    return err;
  });
};
Vue.use(VueRouter);
console.log('routes', routes);
// 导出路由 在 main.js 里使用
var router = new VueRouter({
  routes: routes
  // history模式
  // , history: VueRouter.createWebHistory()
  ,
  mode: 'history'
});
function startRefreshToken() {
  if (localStorage.getItem('refreshTimer')) {
    console.log('清除token定时器');
    clearInterval(localStorage.getItem('refreshTimer'));
  }
  var refreshTimer = setInterval(function () {
    console.log('每隔60秒来检查token');
    store.dispatch('d2admin/account/refreshToken');
  }, 60000);
  localStorage.setItem('refreshTimer', refreshTimer);
}

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var token, userPerms, allow, p;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // 如果是范蠡大模型的网址
          if (window.location.href.indexOf('guoyu-ai.rich-link.cn') != -1) {
            next();
          }
          // console.log('to',to)
          // 确认已经加载多标签页数据 https://github.com/d2-projects/d2-admin/issues/201
          _context.next = 3;
          return store.dispatch('d2admin/page/isLoaded');
        case 3:
          _context.next = 5;
          return store.dispatch('d2admin/size/isLoaded');
        case 5:
          // 进度条
          NProgress.start();

          // 关闭搜索面板
          store.commit('d2admin/search/set', false);

          // 验证当前路由所有的匹配中是否需要有登录验证的
          if (!to.matched.some(function (r) {
            return r.meta.auth;
          })) {
            _context.next = 29;
            break;
          }
          // 这里暂时将cookie里是否存有token作为验证是否登录的条件
          // 请根据自身业务需要修改
          token = localStorage.getItem('token');
          if (!(token && token !== 'undefined')) {
            _context.next = 25;
            break;
          }
          // token过期刷新token
          // store.dispatch('d2admin/account/refreshToken')
          startRefreshToken();
          // 用户已登录，从sessionStorage中获取用户权限信息
          userPerms = localStorage.getItem('userPerms') && localStorage.getItem('userPerms') !== 'undefined' ? JSON.parse(localStorage.getItem('userPerms')) : []; // 添加index
          userPerms.push('/index', "/largeAeration", "/largeFeed", "/largeCockpit", "/largeInspection", "/diagnosis", "/knowledge", "/largeDisease", "/largeSource", "/largeFanli", "/largeProduct", "/digitalTwin", "/largeVideo", "/largeDevice", "/largeEnergy", "/largeWater", "/largeWater_tlf");
          allow = false;
          _context.t0 = _regeneratorRuntime().keys(userPerms);
        case 15:
          if ((_context.t1 = _context.t0()).done) {
            _context.next = 22;
            break;
          }
          p = _context.t1.value;
          if (!(userPerms[p] === to.path || userPerms[p].indexOf(to.path) != -1 && userPerms[p].indexOf('?') != -1)) {
            _context.next = 20;
            break;
          }
          allow = true;
          return _context.abrupt("continue", 15);
        case 20:
          _context.next = 15;
          break;
        case 22:
          if (allow) {
            next();
          } else {
            // next({
            //   name: '411'
            // })
            console.log('411');
          }
          _context.next = 27;
          break;
        case 25:
          // 没有登录的时候跳转到登录界面
          // 携带上登陆成功之后需要跳转的页面完整路径
          next({
            name: 'login',
            query: {
              redirect: to.fullPath
            }
          });

          // https://github.com/d2-projects/d2-admin/issues/138
          NProgress.done();
        case 27:
          _context.next = 30;
          break;
        case 29:
          // 不需要身份校验 直接通过
          next();
        case 30:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function (to) {
  // 进度条
  NProgress.done();
  // 多页控制 打开新的页面
  store.dispatch('d2admin/page/open', to);
  // 更改标题
  util.title(to.meta.title);
});
export default router;